import { message } from "antd";
import { useCallback, useState } from "react";

import { updateBusinessEntity } from "@/api/entities";
import type { BusinessEntityDetailVO } from "@/api/entities/type";

/** useEntityLicense 入参 */
export interface UseEntityLicenseOptions {
  /** 工商实体 ID */
  entityId?: string;
  /** 保存成功后写入详情 */
  applyDetail?: (detail: BusinessEntityDetailVO) => void;
}

/**
 * 营业执照副本：上传/清除后立即调用 updateEntity 落库
 */
export const useEntityLicense = ({ entityId, applyDetail }: UseEntityLicenseOptions) => {
  const [saving, setSaving] = useState(false);

  /** 持久化证照 URL；传空字符串表示清除 */
  const persistLicenseFileUrl = useCallback(
    async (url: string) => {
      if (!entityId) return;
      setSaving(true);
      try {
        const trimmed = url.trim();
        const res = await updateBusinessEntity(entityId, {
          licenseFileUrl: trimmed === "" ? null : trimmed,
        });
        if (res.data) {
          applyDetail?.(res.data);
        }
        message.success(trimmed ? "营业执照已更新" : "营业执照已清除");
      } catch {
        message.error("证照保存失败，请稍后重试");
      } finally {
        setSaving(false);
      }
    },
    [applyDetail, entityId],
  );

  return { saving, persistLicenseFileUrl };
};
